import { AddButton } from '@/common/buttons/AddButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const ProgCotFilterList = ({ progObj }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!progObj) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('progId', progObj.id));
  }, [progObj]);

  const augNavEntityObj = (navEntityObj) => {
      navEntityObj.startDate = progObj.startDate;
      navEntityObj.endDate = progObj.endDate;
    }
    const augTabButtons = (tabButtons) => {
      ObjUtils.clearObj(tabButtons);
      tabButtons.push(<AddButton entity="PROG_COT_FILTER" augNavEntityObj={augNavEntityObj}/>);
    }

  return (
    <EntityList entity="PROG_COT_FILTER" augRowsReq={augRowsReq} augTabButtons={augTabButtons}/>
  )
}